module.exports = __webpack_public_path__ + "img/new-certificado.ee1a6e1f.png";